<template>
  <div class="wrapper wrapper_pc">
    <h2>精選遊戲介紹</h2>
    <div class="con">

      <div class="item">
        <div class="item_con flexCenter">
          <img src="../../assets/imgs/gameInfo/1-l.png" alt="" class="animate__animated animate__fadeInLeft ani01">
          <img src="../../assets/imgs/gameInfo/1-r.png" alt=""
               class="marl26 animate__animated animate__fadeInLeft ani01">
          <div class="intro animate__animated animate__fadeInRight ani01">
            <h2 class="orange fontSize62">
              青雲之上
            </h2>
            <span class="line bg_orange"></span>
            <span class="h2_title orange">
              類型與題材：修仙成長類型題材
            </span>
            <span class="play_info fontWhite">
              玩法介紹：用戶將扮演一名修行者，在靈氣復甦的世界中進行修煉，強大自身，抵抗妖獸，突破自身。 直播間用戶通過「點讚」或指定彈幕
            </span>
            <span class="live_info fontWhite">
              直播間用戶通過「點讚」或指定彈幕生成帶有觀眾名稱的修行者，在修煉區域有32個座位供用戶自行選擇位置。
              在直播間小玩法畫面中同屏互動，通過「點讚」、
              「彈幕」、「禮物」體驗修煉成長之路。
            </span>
          </div>
        </div>
      </div>

      <div class="item" v-show="options.isShowGame2">
        <div class="item_con flexCenter">
          <img src="../../assets/imgs/gameInfo/2-l.png" alt="" class="animate__animated animate__fadeInLeft ani02">
          <img src="../../assets/imgs/gameInfo/2-r.png" alt=""
               class="marl26 animate__animated animate__fadeInLeft ani02">
          <div class="intro animate__animated animate__fadeInRight ani02">
            <h2 class="gray fontSize52 mart2">
              三國霸主•一統江山
            </h2>
            <span class="line bg_gray"></span>
            <span class="h2_title gray">
              類型與題材：三國歷史題材策略遊戲
            </span>
            <span class="play_info gray">
              玩法介紹：玩家化身為三國時期的一名軍士，屯田挖礦、 爵位成長，招募軍士，攻城掠地與其他玩家一決高下。 遊戲強調資源經營與戰場謀
            </span>
          </div>
        </div>
      </div>

      <div class="item" v-show="options.isShowGame3">
        <div class="item_con flexCenter">
          <img src="../../assets/imgs/gameInfo/3-l.png" alt="" class="animate__animated animate__fadeInLeft ani03">
          <img src="../../assets/imgs/gameInfo/3-r.png" alt=""
               class="marl26 animate__animated animate__fadeInLeft ani03">
          <div class="intro animate__animated animate__fadeInRight ani03">
            <h2 class="orange fontSize62 mart3">
              救救灰姑娘
            </h2>
            <span class="line bg_orange"></span>
            <span class="h2_title orange">
              類型與題材：角力對抗類型
            </span>
            <span class="play_info fontWhite">
              玩法介紹：小女孩依靠火爐艱難的在冬日生存，黑暗處還有惡魔對她虎視眈眈，幫助小女孩持續點亮火爐驅散黑暗；還是摧毀火爐抓走小女孩，
            </span>
          </div>
        </div>
      </div>

      <div class="item" v-show="options.isShowGame4">
        <div class="item_con flexCenter">
          <img src="../../assets/imgs/gameInfo/4-l.png" alt="" class="animate__animated animate__fadeInLeft ani04">
          <img src="../../assets/imgs/gameInfo/4-r.png" alt=""
               class="marl26 animate__animated animate__fadeInLeft ani04">
          <div class="intro animate__animated animate__fadeInRight ani04">
            <h2 class="gray fontSize52 mart4">
              向殭屍開炮
            </h2>
            <span class="line bg_gray"></span>
            <span class="h2_title gray">
              類型與題材：末日射擊塔防對抗遊戲
            </span>
            <span class="play_info gray">
              玩法介紹：在殭屍末日中，玩家需要建造防禦工事，升級武器裝備，組建堅強的防線來抵禦殭屍的無盡攻擊。玩家亦可加入殭屍陣營，解鎖殭屍
            </span>
          </div>
        </div>
      </div>

      <div class="item" v-show="options.isShowGame5">
        <div class="item_con flexCenter">
          <img src="../../assets/imgs/gameInfo/5-l.png" alt="" class="animate__animated animate__fadeInLeft ani05">
          <img src="../../assets/imgs/gameInfo/5-r.png" alt=""
               class="marl26 animate__animated animate__fadeInLeft ani05">
          <div class="intro animate__animated animate__fadeInRight ani05">
            <h2 class="orange fontSize62 mart5">
              生化末日
            </h2>
            <span class="line bg_orange"></span>
            <span class="h2_title orange">
              類型與題材：末日生存對抗遊戲
            </span>
            <span class="play_info fontWhite">
              玩法介紹：玩家需要在被病毒侵襲的世界守護者，並守護人類最後的防線帶領倖存軍反攻喪屍巢穴，或成爲墮落於喪屍國度中的王者，並帶著喪
            </span>
          </div>
        </div>
      </div>

      <div class="item" v-show="options.isShowGame6">
        <div class="item_con flexCenter">
          <img src="../../assets/imgs/gameInfo/6-l.png" alt="" class="animate__animated animate__fadeInLeft ani06">
          <img src="../../assets/imgs/gameInfo/6-r.png" alt=""
               class="marl26 animate__animated animate__fadeInLeft ani06">
          <div class="intro animate__animated animate__fadeInRight ani06">
            <h2 class="gray fontSize52 mart6">
              我的書院
            </h2>
            <span class="line bg_gray"></span>
            <span class="h2_title gray">
              類型與題材：古風模擬養成遊戲
            </span>
            <span class="play_info gray">
              玩法介紹：玩家將扮演書院的書生，通過學習不斷提升自己官職，搭配自己喜歡的書籍，發展學堂來提升聲望，最終成爲一等親王，招募伴讀與
            </span>
          </div>
        </div>
      </div>

    </div>
  </div>
</template>

<script>

export default {
  name: "GameInfo",
  props:{
    options:Object
  },
  data: function () {
    return {
      gameInfo: [],
      isShowGame2: false,
      isShowGame3: false,
      isShowGame4: false,
      isShowGame5: false,
      isShowGame6: false,
    };
  },
  mounted() {
  }
};
</script>

<style lang="stylus" scoped>
.flexCenter {
  display: flex;
  justify-content: flex-start;
}

.wrapper {
  width: 100%;
  background: #fff;

  h2 {
    color: #4b4a47;
    font-size: 47px;
    text-align: center;
    margin: 106px 0 20px;
  }

  .con {
    width: 100%;
    margin: 0 auto;
    text-align: center;

    .item {
      margin-bottom: 30px;

      .orange {
        color: #fcc916;
      }

      .bg_orange {
        background: #fcc916;
      }

      .gray {
        color: #4b4a47;
      }

      .bg_gray {
        background: #4b4a47;
      }

      .fontWhite {
        color: white;
      }

      .fontSize62 {
        font-size: 62px;
      }

      .fontSize52 {
        font-size: 52px;
      }

      .mart1 {
        margin-top: 165px;
      }

      .mart2 {
        margin-top: 226px;
      }

      .mart3 {
        margin-top: 221px;
      }

      .mart4 {
        margin-top: 191px;
      }

      .mart5 {
        margin-top: 201px;
      }

      .mart6 {
        margin-top: 206px;
      }

      &:nth-child(1) {
        background: url(../../assets/imgs/gameInfo/1-bg.png) no-repeat;
        background-size: 100% 100%;
      }

      &:nth-child(2) {
        background: url(../../assets/imgs/gameInfo/2-bg.png) no-repeat;
        background-size: 100% 100%;
      }

      &:nth-child(3) {
        background: url(../../assets/imgs/gameInfo/3_bg.jpg) no-repeat;
        background-size: 100% 100%;
      }

      &:nth-child(4) {
        background: url(../../assets/imgs/gameInfo/4_bg.jpg) no-repeat;
        background-size: 100% 100%;
      }

      &:nth-child(5) {
        background: url(../../assets/imgs/gameInfo/5_bg.jpg) no-repeat;
        background-size: 100% 100%;
      }

      &:nth-child(6) {
        background: url(../../assets/imgs/gameInfo/6_bg.jpg) no-repeat;
        background-size: 100% 100%;
      }


      .item_con {
        width: 1367px;
        margin: 0 auto;

        img {
          &:nth-of-type(2) {
            margin-left: -30px;
          }
        }

        .intro {
          font-size: 63px;
          color: #fcc916;
          text-align: left;
          margin-left: 15px;

          h2 {
            text-align: left;
          }

          h2, span {
            display: block;
          }

          .line {
            width: 102px;
            height: 2px;
          }

          .h2_title {
            font-size: 19.44px;
            margin: 18px 0 34px;
          }

          .play_info, .live_info {
            font-size: 18.06px;
            line-height: 35px;
          }

          .play_info {
            margin-bottom: 54px;
          }
        }
      }
    }

    p {
      color: #4b4a47;
      font-size: 20px;
      margin: 18px 0 175px;
    }
  }
}
</style>
